import React from "react";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";

// Регистрация всех Community модулей
ModuleRegistry.registerModules([AllCommunityModule]);

interface AgGridTableProps {
  rowData: any[];
  columnDefs: any[];
  title: string;
  height?: number;
  components?: any;
}

const AgGridTable: React.FC<AgGridTableProps> = ({
  rowData,
  columnDefs,
  title,
  height = 400,
  components,
}) => {
  return (
    <div>
      <h2>{title}</h2>
      <div style={{ height: height, width: "100%" }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          components={components}
        />
      </div>
    </div>
  );
};

export default AgGridTable;

export {};
